import './LicenseFooter.css';

export default function LicenseFooter({ className = '' }) {
  const classes = ['license-footer', className].filter(Boolean).join(' ');

  return (
    <footer className={classes} aria-label="Application footer">
      <div className="license-footer-track">
        <div className="license-footer-group">
          <span className="license-footer-copy">Copyright &copy; 2026 CREDYOU DIGITAL SERVICES PVT LTD</span>
          <span className="license-footer-separator" aria-hidden="true" />
          <span className="license-footer-powered">Powered by BizTrack</span>
        </div>
      </div>
    </footer>
  );
}



